import { Icon, Squircle, Typography, XStack, YStack } from '@shinetools/lumen-react'
import { colors } from '@shinetools/lumen-tokens/web/colors'
import { ChartColumnIncreasing, CheckCheck, Toolbox } from 'lucide-react'
import { ReactElement, useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import * as Styled from './styles'

export const ComingSoonSection = (): ReactElement => {
  const { t } = useTranslation()

  const comingSoonItems = useMemo(
    () => [
      {
        icon: ChartColumnIncreasing,
        title: t('back_to_school.coming_soon.items.advanced_cash_flow.title'),
        description: t('back_to_school.coming_soon.items.advanced_cash_flow.description'),
      },
      {
        icon: CheckCheck,
        title: t('back_to_school.coming_soon.items.automated_reconciliation.title'),
        description: t('back_to_school.coming_soon.items.automated_reconciliation.description'),
      },
      {
        icon: Toolbox,
        title: t('back_to_school.coming_soon.items.ai_connection.title'),
        description: t('back_to_school.coming_soon.items.ai_connection.description'),
      },
    ],
    [t],
  )

  return (
    <YStack gap={24}>
      <YStack align="flex-start" gap={4}>
        <Typography.Header as="h2">{t('back_to_school.coming_soon.title')}</Typography.Header>
        <Typography.Text color={colors.content.neutral.medium} size="small">
          {t('back_to_school.coming_soon.subtitle')}
        </Typography.Text>
      </YStack>

      <XStack gap={8}>
        {comingSoonItems.map(({ icon, title, description }) => (
          <Styled.ComingSoonItem key={title}>
            <Squircle color="neutral" icon={<Icon icon={icon} size="small" />} variant="subtle" />
            <YStack align="flex-start" gap={4}>
              <Typography.Text weight="semibold">{title}</Typography.Text>
              <Typography.Text color={colors.content.neutral.medium} size="small">
                {description}
              </Typography.Text>
            </YStack>
          </Styled.ComingSoonItem>
        ))}
      </XStack>
    </YStack>
  )
}
